import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f040016c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f040016c')) {
      api.createRecord('f040016c', component.options)
    } else {
      api.reload('f040016c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f040016c", function () {
      api.rerender('f040016c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forget/index.vue"
export default component.exports